module.exports = __webpack_public_path__ + "static/media/Under a Blanket.2253c7bb.jpg";